import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import axiosInstance from 'axiosConfig';
import { Toast } from 'components';
import { TOAST_TYPES_ENUM } from 'enums';
import { queryClient } from 'App';

type GarageDoorsInstallationInfoData = {
  measurementUuid: string;
  typeOfInstallation: 'disassemblyAassemblyProcessing' | 'disassemblyAassembly' | 'disassemblyByTheCustomer' | 'rawCondition';
  spoutLevel: 'fromTheProject' | 'specifiedByInvestor' | 'specifiedByContractor';
  spoutLevelValue: string;
  plannedAssemblyTime: string;
  numberOfAssemblyTeams: string;
  isTheOpeningCorrect: 'true' | 'false';
  isTheOpeningCorrectComment?: string;
  theBuildingIsMadeOf: 'ceramicBlock' | 'yTong' | 'silicate' | 'woodenStructure' | 'other';
  theBuildingIsMadeOfComment?: string;
  installationElementsUuids: { uuid: string, comment?: string }[];
  comments?: string;
};

const usePutGarageDoorsInstallationInfo = (
  options?: UseMutationOptions<any, Error, GarageDoorsInstallationInfoData>
) => {
  return useMutation({
    ...options,
    mutationKey: ['editGarageDoorsInstallationInfo'],
    mutationFn: async (data) => {
      return axiosInstance
        .put('/measurement/installation-info/garage-doors', data)
        .then((res) => res.data);
    },
    onMutate: (variables) => {
      Toast({
        message: 'Przetwarzanie danych instalacji bram garażowych...',
        type: TOAST_TYPES_ENUM.LOADING,
        id: 'edit-garage-doors-installation-info',
      });
      if (options && options.onMutate) {
        return options.onMutate(variables);
      }
    },
    onSuccess: (data, variables, context) => {
      Toast({
        message: 'Dane instalacji bram garażowych zaktualizowane pomyślnie.',
        type: TOAST_TYPES_ENUM.SUCCESS,
        id: 'edit-garage-doors-installation-info',
      });
      queryClient.invalidateQueries({ queryKey: ['garageDoorsInstallationInfo'] });
      if (options && options.onSuccess) {
        options.onSuccess(data, variables, context);
      }
    },
    onError: (error, variables, context) => {
      Toast({
        message: 'Błąd podczas aktualizacji danych instalacji bram garażowych.',
        type: TOAST_TYPES_ENUM.ERROR,
        id: 'edit-garage-doors-installation-info',
      });
      if (options && options.onError) {
        options.onError(error, variables, context);
      }
    },
  });
};

export default usePutGarageDoorsInstallationInfo;
